import PATTERNS from '../../../universal/filzfelt/patterns'
import generatePreview from './generate-preview'

export default Object.entries(PATTERNS)
  .map(([id, { name, preview: { width = 72, height = 48 } = {} }]) => ({
    id,
    name,
    preview: generatePreview(id, width, height)
  }))



// WEBPACK FOOTER //
// ./src/client/lib/filzfelt/patterns.js